import Cookies from 'js-cookie'
// this is module for the app states managements

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    //for multi language support
    language: Cookies.get('language') || 'en',

    LoginCard: {
      hidden: true
    },
    modal: {
      show: false,
      component: {}
    }

  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    TOGGLE_LOGIN: (state, hidden) => {
      state.LoginCard.hidden = hidden
    },
    SHOW_MODAL: (state, component) => {
      state.modal.show = !state.modal.show;
      if (state.modal.show) {
        state.modal.component = component;
      }

    }


  },
  actions: {
    showModal({commit}, component) {

      commit('SHOW_MODAL', component)
    },
    toggleSideBar({commit}) {
      commit('TOGGLE_SIDEBAR')
    },
    setLanguage({
                  commit
                }, language) {
      commit('SET_LANGUAGE', language)
    },
    toggle_Login({
                   commit
                 }, hidden) {
      commit('TOGGLE_LOGIN', hidden)
    }

  }
};

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js